
import { createContext, useState, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import CustomerService from "services/customer";
import { CloseButton, Drawer, Portal, Container, VStack, Text, Button, Input } from "@chakra-ui/react"
import { PinInput } from "@/components/ui/pin-input"
import { useApp } from "contexts/app"
import { useStore } from "contexts/store"
const accountService = new CustomerService();

const AuthContext = createContext();

function AuthProvider({ children }) {

    const { setProcessing, setPageTitle, showToast } = useApp();
    const { store } = useStore();

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isLogin, setIslogin] = useState(false);
    const [openLoginBox, setOpenLoginBox] = useState(false);
    const [loginPhone, setLoginPhone] = useState();
    const pinInput = useRef();
    const phoneRef = useRef();
    const accountRef = useRef();
    const passwordRef = useRef();
    const otpIDRef = useRef();
    const loginResolverRef = useRef();
    const loginOptionsRef = useRef({});
    const loginMethod = store?.web?.login_method || "otp";

    useEffect(() => {
        checkLogin();
    }, [])

    const login = async ({ user, token }) => {
        localStorage.setItem("token", token)
        localStorage.setItem("customer_id", user.id);
        try {
            var profile = await accountService.me();
            setUser(profile || user);
            setIslogin(true);
            if (profile?.id) {
                localStorage.setItem("customer_id", profile.id);
            }
            return profile || user;
        } catch (error) {
            setUser(user);
            setIslogin(true);
            return user;
        }
        //window.location = "/"

    }

    const clearLoginState = () => {
        setLoginPhone(null);
        otpIDRef.current = null;
        loginOptionsRef.current = {};
    }

    const finishLoginFlow = (result = null) => {
        setOpenLoginBox(false);
        clearLoginState();
        if (loginResolverRef.current) {
            loginResolverRef.current(result);
            loginResolverRef.current = null;
        }
    }


    const logout = async () => {
        localStorage.removeItem("token")
        localStorage.removeItem("customer_id");
        var redirect = `/`
        setUser(null);
        window.location = redirect;

    }

    const checkLogin = async () => {
        setLoading(true);
        var token = localStorage.getItem("token");

        if (!token) {
            setLoading(false);
            return;
        }
        try {
            var user = await accountService.me();
            if (user) {
                setUser(user);
                setIslogin(true);
                localStorage.setItem("customer_id", user.id);
            } else {
                setUser(null);
                setIslogin(false)
            }

        } catch (error) {
            setUser(null);
            setIslogin(false)
        }

        setLoading(false);

    }

    const requestOTPLogin = async (phone, customer_info) => {
        setProcessing(true);
        const otp = await accountService.requestOTPLogin(phone, customer_info);
        otpIDRef.current = otp.id;
        setProcessing(false);
    }


    const otpLogin = async (id, otp) => {
        return await accountService.otpLogin(id, otp)

    }




    const showLogin = async ({ phone, message, customer_info } = {}) => {
        if (user) {
            return user;
        }

        loginOptionsRef.current = { phone, message, customer_info };
        clearLoginState();
        setOpenLoginBox(true);
        if (loginMethod === "otp" && phone) {
            await requestOTPLogin(phone, customer_info);
            setLoginPhone(phone);
        }

        return await new Promise((resolve) => {
            loginResolverRef.current = resolve;
        });
    }

    const onLoginWithOTP = async () => {
        var phone = phoneRef.current.value;
        await requestOTPLogin(phone, loginOptionsRef.current.customer_info);
        setLoginPhone(phone);
        console.log(phoneRef.current.value)
    }

    const onOtpOk = async () => {
        console.log("onOtpOk", loginPhone, otpIDRef.current, pinInput.current.value)

        setProcessing(true);
        try {
            var data = await accountService.otpLogin(otpIDRef.current, pinInput.current.value);
            var loggedInUser = await login(data);
            finishLoginFlow(loggedInUser);
        } catch (error) {
            showToast({ description: "Mã xác thực sai hoặc hết hạn", type: "error" });
        }

        setProcessing(false)

    }

    const onLoginWithAccount = async () => {
        var account = accountRef.current?.value;
        var password = passwordRef.current?.value;
        if (!account || !password) {
            showToast({ description: "Vui lòng nhập tài khoản và mật khẩu", type: "error" });
            return;
        }

        setProcessing(true);
        try {
            var data = await accountService.accountLogin(account, password);
            var loggedInUser = await login(data);
            finishLoginFlow(loggedInUser);
        } catch (error) {
            showToast({ description: "Tài khoản hoặc mật khẩu không đúng", type: "error" });
        }
        setProcessing(false);
    }


    const test = () => {

        setProcessing(true);
        setTimeout(() => {

            setProcessing(false)
        }, 3000)

    }



    if (loading) {
        return "...";
    }

    return <AuthContext.Provider value={{ user, setUser, login, logout, checkLogin, requestOTPLogin, otpLogin, showLogin }}>
        {children}

        <Drawer.Root
            open={openLoginBox}
            onOpenChange={(e) => {
                if (!e.open) {
                    finishLoginFlow(null);
                }
            }}
            placement={"bottom"}
            closeOnEscape={false}
            closeOnInteractOutside={false}
        >
            <Portal>
                <Drawer.Backdrop />
                <Drawer.Positioner>
                    <Drawer.Content>
                        <Container maxW={"md"}>
                            <Drawer.Header>
                                <Drawer.Title>Đăng nhập</Drawer.Title>

                            </Drawer.Header>

                            <Drawer.Body>
                                {loginMethod === "otp" && loginPhone &&
                                    <VStack>
                                        <Text>
                                            Mã xác nhận đã được gửi tới {loginPhone}
                                        </Text>
                                        <Text>
                                            Mã xác nhận
                                        </Text>
                                        <PinInput ref={pinInput} otp />
                                    </VStack>

                                }

                                {loginMethod === "otp" && !loginPhone &&
                                    <VStack>

                                        <Text>
                                            Số điện thoại
                                        </Text>
                                        <Input placeholder="Số điện thoại của bạn" ref={phoneRef} type="tel" />
                                    </VStack>

                                }

                                {loginMethod === "account" &&
                                    <VStack>
                                        <Text>
                                            Tài khoản
                                        </Text>
                                        <Input placeholder="Nhập tài khoản" ref={accountRef} />
                                        <Text>
                                            Mật khẩu
                                        </Text>
                                        <Input placeholder="Nhập mật khẩu" type="password" ref={passwordRef} />
                                    </VStack>

                                }




                            </Drawer.Body>
                            <Drawer.Footer>
                                <Button variant="outline" onClick={e => finishLoginFlow(null)}>Cancel</Button>
                                {loginMethod === "otp" && (loginPhone ?
                                    <Button onClick={onOtpOk}>Xác nhận</Button>
                                    :
                                    <Button onClick={onLoginWithOTP}>Tiếp tục</Button>

                                )}

                                {loginMethod === "account" &&
                                    <Button onClick={onLoginWithAccount}>Đăng nhập</Button>
                                }

                            </Drawer.Footer>

                        </Container>
                    </Drawer.Content>
                </Drawer.Positioner>
            </Portal>
        </Drawer.Root>

    </AuthContext.Provider>;
}



const useAuth = () => {
    const context = useContext(AuthContext);
    return context;
};

export { AuthProvider, useAuth };

